// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__0II_j","white":"Breadcrumbs_white__d3CUr","breadcrumb":"Breadcrumbs_breadcrumb__pq59J","black":"Breadcrumbs_black__tzzGL"};